export const BEACON_MODES = {
    LIGHT: 'beacon-on-light',
    LIGHTER: 'beacon-on-lighter',
    DARK: 'beacon-on-dark',
    DARKER: 'beacon-on-darker',
};
export const BEACON_MODE_CLASSNAMES = Object.values(BEACON_MODES);
export const BEACON_MODES_INVERSE = {
    [BEACON_MODES.LIGHT]: BEACON_MODES.DARK,
    [BEACON_MODES.LIGHTER]: BEACON_MODES.DARKER,
    [BEACON_MODES.DARK]: BEACON_MODES.LIGHT,
    [BEACON_MODES.DARKER]: BEACON_MODES.LIGHTER,
};
export const BEACON_MODES_ALTERNATIVE = {
    [BEACON_MODES.LIGHT]: BEACON_MODES.LIGHTER,
    [BEACON_MODES.LIGHTER]: BEACON_MODES.LIGHT,
    [BEACON_MODES.DARK]: BEACON_MODES.DARKER,
    [BEACON_MODES.DARKER]: BEACON_MODES.DARK,
};
//# sourceMappingURL=constants.js.map